import { Link } from "@tanstack/react-router";

import { PLACES_BY_SLUG } from "@/lib/local-seo";
import { FOCUS_PLACE_SLUGS } from "@/lib/focus-places";

/**
 * Inklapbaar werkgebied-blok in de footer: zichtbaar en klikbaar voor iedere
 * bezoeker (geen verborgen links), maar compact zodat het de pagina niet vult.
 */
export function FooterPlaceLinks({ locale }: { locale: "nl" | "en" }) {
  const places = FOCUS_PLACE_SLUGS.map((s) => PLACES_BY_SLUG.get(s)).filter(
    (p): p is NonNullable<typeof p> => Boolean(p),
  );
  const nl = locale === "nl";
  return (
    <details className="group border-t border-border">
      <summary className="mx-auto flex max-w-6xl cursor-pointer list-none items-center justify-between px-4 py-4 text-sm font-semibold text-foreground sm:px-6 lg:px-8">
        {nl ? "Taxi in uw plaats en naar Schiphol" : "Taxi in your town and to Schiphol"}
        <span aria-hidden className="text-muted-foreground transition-transform group-open:rotate-180">
          ▾
        </span>
      </summary>
      <div className="mx-auto grid max-w-6xl gap-6 px-4 pb-8 sm:grid-cols-2 sm:px-6 lg:px-8">
        <div>
          <div className="text-xs font-semibold uppercase tracking-wide text-foreground">
            {nl ? "Taxi per plaats" : "Taxi by town"}
          </div>
          <ul className="mt-2 flex flex-wrap gap-x-3 gap-y-1.5 text-xs text-muted-foreground">
            {places.map((p) => (
              <li key={p.slug}>
                {nl ? (
                  <Link to="/taxi/$plaats" params={{ plaats: p.slug }} className="hover:text-primary">
                    Taxi {p.name}
                  </Link>
                ) : (
                  <Link to="/en/taxi/$place" params={{ place: p.slug }} className="hover:text-primary">
                    Taxi {p.name}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </div>
        <div>
          <div className="text-xs font-semibold uppercase tracking-wide text-foreground">
            {nl ? "Taxi naar Schiphol" : "Taxi to Schiphol"}
          </div>
          <ul className="mt-2 flex flex-wrap gap-x-3 gap-y-1.5 text-xs text-muted-foreground">
            {places.map((p) => (
              <li key={p.slug}>
                {nl ? (
                  <Link to="/taxi/$plaats/schiphol" params={{ plaats: p.slug }} className="hover:text-primary">
                    {p.name} – Schiphol
                  </Link>
                ) : (
                  <Link to="/en/taxi/$place/schiphol" params={{ place: p.slug }} className="hover:text-primary">
                    {p.name} – Schiphol
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </details>
  );
}
